import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { WidgetType } from 'src/app/classes';
import { WidgetService } from 'src/app/services/widget.service';
import { WidgetTypeMap } from '../widget-globals';

@Component({
  selector: 'app-select-widgettype',
  templateUrl: './select-widgettype.component.html',
  styleUrls: ['./select-widgettype.component.css']
})
export class SelectWidgettypeComponent implements OnInit {

  widgetTypes: { type: WidgetType, pretty: string }[] = [];
  widgetTypesLoaded: boolean = false;
  widgetTypesLoadingSubscription: Subscription;

  constructor(
    private _dialogRef: MatDialogRef<SelectWidgettypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private _widgetService: WidgetService
  ) { }

  close() {
    this._dialogRef.close();
  }

  ngOnInit(): void {
    this._widgetService.loadAllWidgetTypes().subscribe((widgetTypes: WidgetType[]) => {
      for (let type of widgetTypes) {
        let internal = WidgetTypeMap[type.wtypename];
        if (!internal) continue;
        this.widgetTypes.push({ type: type, pretty: internal.pretty });
      }
    });
  }

  selectType(type: WidgetType) {
    this.data = type.wtypeid;
    this._dialogRef.close(type.wtypeid);
  }

}
